import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationDischarge1MasterReferenceData = createAsyncThunk(
  'stop/getVerificationDischarge1MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationDischarge1MasterReferenceSlice = createSlice({
  name: 'stop/verificationDischarge1MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationDischarge1MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationDischarge1MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationDischarge1MasterReference } =
  verificationDischarge1MasterReferenceSlice.actions;

export default verificationDischarge1MasterReferenceSlice.reducer;
